import { Table } from 'dexie';
import { Injectable } from '@angular/core';
import { ItemProduct } from '../models/item-product.model';
import { DexieDatabaseBase } from './dexie-hardening';

export interface ItemProductMeta {
  key: string;
  value: string;
}

@Injectable({ providedIn: 'root' })
export class ItemProductDatabase extends DexieDatabaseBase {
  items!: Table<ItemProduct, string>;
  meta!: Table<ItemProductMeta, string>;

  constructor() {
    super('NexusItemProductDB');

    this.version(1).stores({
      items: 'product',
    });

    this.version(2).stores({
      items: 'product',
      meta: 'key',
    });
  }
}
